<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.teams')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.team.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.team.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table [value]="teams" [paginator]="true" [rows]="20" stateStorage="local" stateKey="team-list">
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-team>
            <tr (click)="onOpen(team)" (keyup.enter)="onOpen(team)" hoverOnRight="admin.team.show" tabindex="0">
              <td><span role="link">{{team.name}}</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
